import { removeAlert } from './render.js';

/**
 * Handle click events for the alert container via event delegation
 * @param {Event} e - Click event
 */
export function handleClick(e) {
	// Handle close button click
	const closeBtn = e.target.closest('.alert-icon-close');
	if (closeBtn) {
		handleCloseClick(closeBtn);
		return;
	}
}

/**
 * Internal handler for closing an alert
 * @param {HTMLElement} btn - The close button that was clicked
 */
function handleCloseClick(btn) {
	const alert = btn.closest('.alert');
	if (alert) {
		removeAlert(alert);
	}
}
